import { render } from "./MarketplaceCard.vue?vue&type=template&id=5ce38855"
import script from "./MarketplaceCard.vue?vue&type=script&lang=js"
export * from "./MarketplaceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__